
import { useState } from 'react';
import { Load } from '../types';
import { useToast } from '@/hooks/use-toast';

export const useRecommendations = (loads: Load[], setLoads: React.Dispatch<React.SetStateAction<Load[]>>) => {
  const [activeRecommendation, setActiveRecommendation] = useState<string | null>(null);
  const { toast } = useToast();

  const toggleRecommendation = (recId: string) => {
    setActiveRecommendation(activeRecommendation === recId ? null : recId);
  };

  const implementRecommendation = (loadId: string, recId: string) => {
    setLoads(prevLoads => 
      prevLoads.map(load => 
        load.id === loadId 
          ? { 
              ...load, 
              recommendations: load.recommendations.filter(rec => rec.id !== recId)
            } 
          : load
      )
    );

    toast({
      title: "Recommendation implemented",
      description: "The efficiency recommendation has been applied successfully.",
    });

    setActiveRecommendation(null);
  };

  return {
    activeRecommendation,
    toggleRecommendation,
    implementRecommendation,
  };
};
